import * as React from 'react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import TrashBinDataTable from 'modules/documents/components/TrashBin/TrashBinDataTable'
import { SPACES } from 'modules/documents/lib/constants'

const CompanyInternalTrashPage = () => {
  const { navigation } = useNavigation()

  return (
    <TrashBinDataTable
      space={SPACES.COMPANY_INTERNAL}
      getItemRoute={(documentId) =>
        navigation.files.trash.company_internal.documentId.fullPath({ document_id: documentId })
      }
      parentRoute={navigation.files.trash.company_internal.fullPath()}
    />
  )
}

export default CompanyInternalTrashPage
